/* eslint-disable  max-classes-per-file */
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import DOMReady from '../utils/DOMReady'

// Include css for webpack (for development only)
const css = require('../../css/blocks/case-studies.scss') // eslint-disable-line no-unused-vars

class CaseStudies {
  constructor(el) {
    this.container = el
    this.swiper = this.container.querySelector('.case-studies__slider')
    this.next = this.container.querySelector('.case-studies__controls-next')
    this.prev = this.container.querySelector('.case-studies__controls-prev')

    if (this.swiper) {
      this.slider = new Swiper(this.swiper, {
        modules: [Navigation],
        slidesPerView: 1,
        slidesToSlide: 1,
        navigation: {
          nextEl: this.next,
          prevEl: this.prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesToSlide: 3,
            spaceBetween: 20,
          },
        },
      })

      this.slider.init()
    }
  }
}

class CaseStudyModal {
  constructor(el) {
    this.container = el
    this.swiper = this.container.querySelector('.swiper')
    this.next = this.container.querySelector('.case-studies__modal__controls-next')
    this.prev = this.container.querySelector('.case-studies__modal__controls-prev')

    if (this.swiper) {
      this.slider = new Swiper(this.swiper, {
        modules: [Navigation],
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: this.next,
          prevEl: this.prev,
        },
      })

      this.slider.init()
    }
  }
}

DOMReady(() => {
  const wrapperEl = document.querySelectorAll('.case-studies')
  Array.from(wrapperEl).forEach(el => {
    // eslint-disable-next-line no-new
    new CaseStudies(el)
  })

  const modalEl = document.querySelectorAll('.modal--case')
  Array.from(modalEl).forEach(el => {
    // eslint-disable-next-line no-new
    new CaseStudyModal(el)
  })
})
